import { useQuery } from '@tanstack/react-query';
import moment from 'moment/moment';

import {
  GetFluxNextExecutionTimeResponseDto,
  GetFluxNextExecutionTimeResponseDtoFluxTypeEnum,
} from 'lib_api/lib/api/gen';

import { DATE_FORMAT_WITH_TIME } from 'utils/formats';

import { useApi } from '../ApiStoreContext';
import { useHandleBackErrors } from '../utils/handleBackErrors';

function useNextExecutionTime(
  fluxType: GetFluxNextExecutionTimeResponseDtoFluxTypeEnum,
): string {
  const behaviourOnError = useHandleBackErrors();
  const controller = useApi().AdminFonctionnelControllerApi;

  function fetchNextExecutionTime(): Promise<void | GetFluxNextExecutionTimeResponseDto> {
    return controller
      .getNextExecutionTimeUsingGET(fluxType)
      .catch(behaviourOnError);
  }

  const result = useQuery({
    queryKey: ['nextExecutionTime', fluxType],
    queryFn: fetchNextExecutionTime,
  });

  return result.data
    ? moment(result.data?.nextExecutionTime).format(DATE_FORMAT_WITH_TIME)
    : 'Aucune exécution programmée';
}

export default useNextExecutionTime;
